import { onMounted, onUnmounted } from 'vue';
const keyConfigs = {
    Escape: {
        code: 27,
        alternative: 'Esc',
    },
    Enter: {
        code: 13,
    },
    ArrowLeft: {
        code: 37,
    },
    ArrowRight: {
        code: 39,
    },
};
/** Registers a keyup listener, optionally filtered by key(s), auto-cleaning up on unmount. */
export function onKeyUp(keyOrCallback, callback) {
    if (typeof keyOrCallback === 'function') {
        callback = keyOrCallback;
    }
    else {
        const keys = typeof keyOrCallback === 'string' ? [keyOrCallback] : keyOrCallback;
        const originalCallback = callback;
        callback = e => {
            for (const key of keys) {
                if (isMatchingKey(e, key)) {
                    originalCallback(e);
                    return;
                }
            }
        };
    }
    onMounted(() => {
        document.addEventListener('keyup', callback);
    });
    onUnmounted(() => {
        document.removeEventListener('keyup', callback);
    });
}
function isMatchingKey(event, key) {
    const keyConfig = keyConfigs[key];
    if ('key' in event) {
        return event.key === key || (keyConfig.alternative != null && event.key === keyConfig.alternative);
    }
    else {
        return event.keyCode === keyConfig.code;
    }
}
//# sourceMappingURL=onKeyUp.js.map